import { tEnv } from "tmt_api/src/types/types.validator";

/**
 * Environment Variables
 */
/** *** */

export const kEnv: tEnv = "prod";
export const DEBUG_URL = "http://localhost:5001/bb-tmt-prod/us-central1/api";
export const LIVE_URL = "https://us-central1-bb-tmt-prod.cloudfunctions.net/api";
export const API_URL = LIVE_URL;
export const DEBUG_PDFS_URL = "http://localhost:5001/bb-tmt-prod/us-central1/pdfs";
export const LIVE_PDFS_URL = "https://us-central1-bb-tmt-prod.cloudfunctions.net/pdfs";
export const PDFS_URL = LIVE_PDFS_URL;
export const LOCAL_FIRESTORE_URL = "localhost:8081";
export const kDefaultProfileURL =
  "https://firebasestorage.googleapis.com/v0/b/bb-tmt-prod.appspot.com/o/defaultProfileURL%2FProfile.jpg?alt=media&token=322eaa66-c5d6-4145-895f-307880846564";
export const STORE_URL = "https://supertest1.mybigcommerce.com";

const ALGOLIA_PROD = true;
export const ALGOLIA_APP_ID = "B99XXM5SWN";
export const ALGOLIA_SEARCH_KEY = "e186d554dc5091174572d3df322371de";
export const ALGOLIA_BRANDS = {
  DEFAULT: ALGOLIA_PROD ? "tmt_brands" : "dev_brands",
  NEW: ALGOLIA_PROD ? "tmt_brands_new" : "dev_brands_new",
  PRICE_ASC: ALGOLIA_PROD ? "tmt_brands_price_asc" : "dev_brands_price_asc",
  PRICE_DESC: ALGOLIA_PROD ? "tmt_brands_price_desc" : "dev_brands_price_desc",
};
export const ALGOLIA_PRODUCTS = {
  LAST_MODIFIED: ALGOLIA_PROD ? "tmt_products" : "dev_products",
  PRICE_ASC: ALGOLIA_PROD ? "tmt_products_price_asc" : "dev_products_price_asc",
  PRICE_DESC: ALGOLIA_PROD ? "tmt_products_price_desc" : "dev_products_price_desc",
} as const;

/** getBalance url */
// TODO: FOR PRODUCTION MAKE SURE TO change the public/index.html file:
//  uncomment line 13 and comment line 11 so that the src is for production
export const getBalanceDEBUG = "sandbox.";
export const getBalanceLIVE = "";
export const getBalancePrefix = getBalanceLIVE;

/** Firebase */
export const FirebaseConfig = {
  apiKey: "AIzaSyAEU9Gd2m7oQWOnHM4JD6EjhCoCHtn5uuY",
  authDomain: "bb-tmt-prod.firebaseapp.com",
  projectId: "bb-tmt-prod",
  storageBucket: "bb-tmt-prod.appspot.com",
  messagingSenderId: "385105864668",
  appId: "1:385105864668:web:49368493a4b7cd025b1119",
  measurementId: "G-XTDXNBPC8F",
};
